const NUM_OF_QUESTIONS = [
  { key: 10, text: 10, value: 10 },
  { key: 20, text: 20, value: 20 },
  { key: 30, text: 30, value: 30 },
  { key: 40, text: 40, value: 40 },
  { key: 50, text: 50, value: 50 },
  { key: 60, text: 60, value: 60 },
];

export default NUM_OF_QUESTIONS;
